import { useEffect, useState } from "react";
import { DEV_ENV_PATH, type DevEnvInfo } from "@aquaduck/shared";

let cached: Promise<DevEnvInfo | null> | undefined;
export function fetchDevEnv() {
  return cached ??= fetch(DEV_ENV_PATH).then(async response => {
    if (!response.ok) return null;
    return await response.json() as DevEnvInfo;
  }).catch(() => null);
}
export function useDevEnv() {
  const [env, setEnv] = useState<DevEnvInfo | null>(null);
  useEffect(() => { let active = true; void fetchDevEnv().then(value => { if (active) setEnv(value); }); return () => { active = false; }; }, []);
  return env;
}
export class DevRequestError extends Error {
  constructor(message: string, readonly status: number) { super(message); }
}
export async function devRequest<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, init);
  if (!response.ok) {
    const body = await response.json().catch(() => null) as { error?: string } | null;
    throw new DevRequestError(body?.error || `Request failed (${response.status})`, response.status);
  }
  return await response.json() as T;
}
